











import Vue from 'vue'
import { CHART_SIZE } from '../sizes'

export default Vue.extend({
  name: 'AxisY1Title',
  data: () => ({ CHART_SIZE }),
})
